import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { PostCjResponseResultModel } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class ProgressStateUiService {

  public postCjResponseResult$: Observable<PostCjResponseResultModel>;

  public deferProgressUntill(deferObserver: Observable<PostCjResponseResultModel>) {
    this.postCjResponseResult$ = deferObserver;
  }
}
